module.exports = __webpack_public_path__ + "static/media/Rubik-Medium.b3a69b72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/Rubik-Medium/Rubik-Medium.svg
// module id = 1305
// module chunks = 49